export default __webpack_public_path__ + "static/media/080_finish_bad.last.67b2405d.webp";